import * as callbacks from './callbacks'
import * as handlers from './handlers'
import { newRTCPeerConnection } from './createRTCPConn'
const webrtc = {
  callbacks,
  handlers,
  newRTCPeerConnection,
}
export default webrtc
